import React from "react";
import { EventContext } from "../context/EventContext";

export const useEventContext = () => React.useContext(EventContext);
